import { render, staticRenderFns } from "./Wizardot1show.vue?vue&type=template&id=125af6ac&"
import script from "./Wizardot1show.vue?vue&type=script&lang=js&"
export * from "./Wizardot1show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports